import React,{useState} from 'react';
import { IAppPropsWithRoute } from "../../common/types";
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
//import { showNavbar } from '../../store/modules/appStateSlice';
import { Grid, Button, Theme, makeStyles, CircularProgress, AppBar, Toolbar, } from "@material-ui/core";
import { ArrowForwardIos } from "@material-ui/icons";
//import Navbar from ".././shared/Navbar";
import { RootState } from "../../store/rootReducer";
import { useStyles } from "./styles";
import RightHandMenu from ".././shared/RightHandMenu";
import LeftHandMenu from ".././shared/LeftHandMenu";
import { Fragment } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import AddMemberPopup from "./AddMemberPopup";
import UserListIconSvg from "../../assets/icons/team_members/user.svg";
import TickIconSvg from "../../assets/icons/team_members/tick.svg";
import RemoveIconSvg from "../../assets/icons/team_members/remove.svg";
import api from "../../store/api";
import { setLoading } from '../../store/modules/plannerLoadingSlice';
import eventNames from '../../store/signalr/eventNames';
import { addTaskForEvent, removeTaskForEvent } from '../../store/signalr/tasksForEvents';
import { useHistory } from "react-router-dom";
import tr from 'date-fns/esm/locale/tr/index.js';
import { consts } from "../../common/consts";
import navBarLogo from "../../assets/images/navBarLogo.svg";
interface TeamMembersProps extends IAppPropsWithRoute {
    //
};
interface TMType {
    id: number,
    name: string,
    loading: boolean,
};
interface NavBarProps extends IAppPropsWithRoute {
    righButtonName?: string;
    humberMenu?: JSX.Element | null;
    rightButton?: JSX.Element | null;
    noLogo?: boolean;
    noNavBarShadow?: boolean;
  }
  
interface IUserData {
    givenName: string;
    surName: string;
    email: string;
    role: string;
    IsAdmin: boolean;
    exp: number;
    location: string;
    ward: string;
  }
  
  interface IAuthState {
    isAuthenticated?: boolean;
    token: string | null;
    userName: string | null;
    data: IUserData | null;
    sessionExpired: boolean;
    vehicleSessionId: string | null;
    vehicleNumber: string | null;
  }
  interface IUserType {
    IsAdmin: boolean | false;
    SMADriver: boolean | false;
    CanViewDashBoard: boolean | false;
  }
  
const TeamMembersWidget: React.FC<TeamMembersProps> = (props:TeamMembersProps): JSX.Element =>{
    const componentTaskId = "teamMembers";
    const history = useHistory();
    const dispatch = useDispatch();
    const classes = useStyles();
    const [users, setUsers] = React.useState<any>([]);
    const [teamMember1, setTeamMember1] = React.useState<TMType | null>(null);
    const [teamMember2, setTeamMember2] = React.useState<TMType | null>(null);  
    const [teamMember1val, setTeamMember1val] = React.useState<boolean>(false);
    const [teamMember2val, setTeamMember2val] = React.useState<boolean>(false); 
    const [teamMember1email, setTeamMember1email] =  React.useState("");
    const [teamMember2email, setTeamMember2email] =  React.useState("");  
    const { appState, authStore } = useSelector((state: RootState) => state);
    const [vehicleNo, setvehicleNo] = React.useState(null);
    const [value, setValue ] = React.useState(null);
    const [addMemberPopup1, setAddMemberPopup1] = React.useState<boolean>(false);
    const [addMemberPopup2, setAddMemberPopup2] = React.useState<boolean>(false);
    const [isSMAUser, setIsSMAUser] = useState((authStore.data?.IsSMAUser != null) ? authStore.data?.IsSMAUser : true);
    const [initialRender1, setinitialRender1] =  React.useState(true);
    const [initialRender2, setinitialRender2] =  React.useState(true);  
    const [initialdelete1, setinitialdelete1] =  React.useState(false);
    const [initialdelete2, setinitialdelete2] =  React.useState(false);  
    const [initialload1, setinitialload1] =  React.useState(false);
    const [initialload2, setinitialload2] =  React.useState(false);  
    const [displaybtn, setdisplaybtn] =  React.useState(false);  
    const whennewteammembersDo = async (e:any) => {
        await getFullActiveMembers();
        if(e.TeamMemberUserId === teamMember1?.id && e.Acknowledged === true)
        {
            setTeamMember1val(true)
            setdisplaybtn(false)
        }
        if(e.TeamMemberUserId === teamMember2?.id && e.Acknowledged === true)
        {
            setTeamMember2val(true)
            setdisplaybtn(false)
        }
       console.log(e);
    }
    React.useEffect(() => {   
        addTaskForEvent(eventNames.newTeammember, componentTaskId, whennewteammembersDo);       
        return () => {
            removeTaskForEvent(eventNames.newTeammember, componentTaskId);
          };
        //setTeamMember1({ id: 10, name: "Duncan Matthews", loading: true });
        // setTimeout(() => {
        //     setTeamMember1((p: any) => ({ ...p, loading: false }));
        // }, 5000);
    }, [whennewteammembersDo]);
    React.useEffect(() => { 
        checkteammember()   
        getusers();      
     }, []);
    const checkteammember = async()=>{
        await getFullActiveMembers();
        const vehicleSessionId = authStore.vehicleSessionId;
        var res =await api.GetTeammembers('Vehiclesessionid=' + vehicleSessionId);      
        if(res.model !=null)
        {    
            if(res.model.length>1)
            {
              setinitialRender1(true)
              setinitialRender2(true)
              if(res.model[0].acknowledged === false)
              {
                setTeamMember1(res.model[0]); 
                setdisplaybtn(true);
                if(res.model[0].email === true)
                {
                    setTeamMember1email("Email")
                }
                else
                {
                    setTeamMember1email("SMS")
                }
                setTeamMember1val(false);  
              }
              else
              {
                setTeamMember1(res.model[0]);                
                setTeamMember1val(true);
              }
              if(res.model[1].acknowledged === false)
              {
                setdisplaybtn(true);
                setTeamMember2(res.model[1]); 
                if(res.model[1].email === true)
                {
                    setTeamMember2email("Email")
                }
                else
                {
                    setTeamMember2email("SMS")
                }
                setTeamMember2val(false);
              }
              else
              {
                setTeamMember2(res.model[1]);              
                setTeamMember2val(true);
              }
                
            }     
            else{
                setinitialRender1(true)
                if(res.model[0].acknowledged === false)
                {
                    setdisplaybtn(true);
                  setTeamMember1(res.model[0]); 
                  if(res.model[0].email === true)
                  {
                      setTeamMember1email("Email")
                  }
                  else
                  {
                      setTeamMember1email("SMS")
                  }
                  setTeamMember1val(false);  
                }
                else
                {
                    setTeamMember1(res.model[0]);                  
                    setTeamMember1val(true);
                }
            } 
         
            
        }        
    }
    const getusers = async()=>{
        await getFullActiveMembers();
        var res =await api.getuser("")
        if(res.model !=null)
        {
            if(teamMember1 !== null)
            {
                setUsers(res.model.filter((x:any) => x.id != teamMember1.id));
            }
            else if (teamMember2 !== null){
                setUsers(res.model.filter((x:any) => x.id != teamMember2.id));
            }
            else
            {
                setUsers(res.model);
            }
         
        }        
    }
    React.useEffect(() => {  
            if(teamMember1!=null && !initialRender1)
            {    
                var res = getMessage(teamMember1.id);                      
                return      
            } 
            else
            {    
                if(initialdelete1)  
                {
                    setinitialdelete1(false);
                }            
                return 
            }                          
        }, [teamMember1]);
    React.useEffect(() => {         
            if(teamMember2!=null && !initialRender2)
            {                        
                getMessage2(teamMember2.id);                        
                return      
            }  
            else
            {     
                if(initialdelete1)  
                {
                    setinitialdelete1(false);
                }           
                return 
            }                       
        }, [teamMember2]);
     React.useEffect(() => {                    
            if(initialdelete1)  
            {
                setinitialdelete1(false);
                setAddMemberPopup1(false);
                setTeamMember1val(false); 
            }           
            return                                   
        }, [initialdelete1]);
        React.useEffect(() => {                    
            if(initialdelete2)  
            {
                setinitialdelete2(false);
                setAddMemberPopup2(false);
                setTeamMember2val(false); 
            }           
            return                                   
        }, [initialdelete2]);
    const getMessage = async(id:any) =>{
            setTeamMember1email("")
            setdisplaybtn(true)
            var vehicleSessionId = authStore.vehicleSessionId || null;
            var res =await api.createsession('id=' + id+'&vehicleSessionId=' +vehicleSessionId)
            if(res.appId !==null)
            {
                var res =await api.createemail('id=' + res.appId)    
                if(res.appId!=null)
                {
                    if(res.appId.email === true)
                    {                  
                        setTeamMember1email("Email")
                    }
                    else{
                        setTeamMember1email("SMS")
                    }
                }  
                else
                {
                    console.log(res);
                }                                             
                return true
            } 
            else{    
                console.log(res);        
                //setTeamMember1((p: any) => ({ ...p, loading: true }));
                return true
            }             
        } 
    const getMessage2 = async(id:any) =>{
            setTeamMember2email("");
            setdisplaybtn(true);
            var vehicleSessionId = authStore.vehicleSessionId || null;
            var res =await api.createsession('id=' + id+'&vehicleSessionId=' +vehicleSessionId)
            if(res.appId !==null)
            {
                var res =await api.createemail('id=' + res.appId)
                if(res.appId!=null)
                {
                    if(res.appId.email === true)
                    {
                        setTeamMember2email("Email");
                    }
                    else{
                        setTeamMember2email("SMS");
                    }
                }
                else
                {
                    console.log(res);
                }                                                                    
                return true
            } 
            else{  
                console.log(res);  
                //setTeamMember1((p: any) => ({ ...p, loading: true }));
                return true
            }             
        } 
    const redirectToNext=()=>{
        console.log(consts.Permissions.ViewDashboard);
        var permissions = authStore.data?.role.split(",");
        if (permissions) {
            if (permissions.indexOf(consts.Permissions.ViewDashboard) > 0 || permissions.indexOf(consts.Permissions.SMAAdminPatientTransportDashboard) > 0) {
                props.history.push('/dashboard');
            }
            else if(permissions.includes(consts.Permissions.RequestCallout)){
                props.history.push('/requestcallout');
            }
            //else if (permissions.includes(consts.Permissions.SMAMakeBooking) || permissions.includes(consts.Permissions.makeBooking)  || permissions.includes("")) {
            //    if (permissions.includes(consts.Permissions.SMAMakeBooking) || permissions.includes(consts.Permissions.makeBooking)){
            //        setdisableBooking(false);
            //    }
            //    // Redirect to Landing page
            //    props.history.push('/');
            //}
            else if(permissions.includes(consts.Permissions.ManageCustomerVehicles) && permissions.indexOf(consts.Permissions.ViewSchedule) == -1 && permissions.indexOf(consts.Permissions.SMAViewSchedule)==-1 && authStore?.data?.IsAdmin==false){
                props.history.push('/managevehicles');
            }
            else if(permissions.includes(consts.Permissions.ViewCustomerTransferHistory) && permissions.indexOf(consts.Permissions.ViewSchedule) == -1 && permissions.indexOf(consts.Permissions.SMAViewSchedule)==-1 && authStore?.data?.IsAdmin==false){
                props.history.push('/transfers/0');
            }
            else if(permissions.includes(consts.Permissions.SMAAdminManageUsers) && permissions.indexOf(consts.Permissions.ViewSchedule) == -1 && permissions.indexOf(consts.Permissions.SMAViewSchedule)==-1 && authStore?.data?.IsAdmin==false){
                props.history.push('/settings/users');
            }
            else if(permissions.includes(consts.Permissions.SMAAdminManageUserprofiles) && permissions.indexOf(consts.Permissions.ViewSchedule) == -1 && permissions.indexOf(consts.Permissions.SMAViewSchedule)==-1 && authStore?.data?.IsAdmin==false){
                props.history.push('/settings/profiles');
            }
            else if(permissions.includes(consts.Permissions.ManageUsers) && permissions.indexOf(consts.Permissions.ViewSchedule) == -1 && permissions.indexOf(consts.Permissions.SMAViewSchedule)==-1 && authStore?.data?.IsAdmin==false){
                props.history.push('/manageusers');
            }
            else if(permissions.includes(consts.Permissions.ViewPCR) && permissions.indexOf(consts.Permissions.ViewSchedule) == -1 && permissions.indexOf(consts.Permissions.SMAViewSchedule)==-1 && authStore?.data?.IsAdmin==false){
                props.history.push('/patientCareRecord/viewpcr/0/false');
            }
            else if(permissions.includes(consts.Permissions.SMASubmitPatientCareRecords) && permissions.indexOf(consts.Permissions.ViewSchedule) == -1 && permissions.indexOf(consts.Permissions.SMAViewSchedule)==-1 && authStore?.data?.IsAdmin==false){
                props.history.push('/patientCareRecord');
            }
            else if(permissions.includes(consts.Permissions.SubmitPatientCareRecord) && permissions.indexOf(consts.Permissions.ViewSchedule) == -1 && permissions.indexOf(consts.Permissions.SMAViewSchedule)==-1 && authStore?.data?.IsAdmin==false){
                props.history.push('/patientCareRecord');
            }
            //TODO: redirect to proper location
            else {
                props.history.push('/transferschedule');
            }
        }
    }
    const getFullActiveMembers=async ()=>{
        const vehicleSessionId = authStore.vehicleSessionId;
        var res =await api.GetFullActiveTeammembers('Vehiclesessionid=' + vehicleSessionId+'&Version='+Math.random()+Math.random()+Math.random()); 
        if (res!=undefined||res!=null){
            if(res.model!=undefined||res.model!=null||res.model.length>0){
                localStorage.removeItem("CurrentTeamMembers");
                localStorage.setItem("CurrentTeamMembers",JSON.stringify(res.model));
            }
        }  
    }
    const oncontinue = async () =>{     
        await getFullActiveMembers();
           if(teamMember1val && teamMember1 !== null)      
           {
            localStorage.setItem("TeammemberContinue","Yes")  
            redirectToNext();
           }
           else if(teamMember2val !== null && teamMember2 !== null)
           {
            localStorage.setItem("TeammemberContinue","Yes")  
            redirectToNext();
           }
           else if (teamMember1 === null && teamMember2 === null)
           {
            localStorage.setItem("TeammemberContinue","Yes")  
            redirectToNext();
           }
          else
          {
            console.log("Notconfirmed");
          }
        }
        React.useEffect(() => {        
            if(addMemberPopup1 == true)
            {     
                if(initialdelete1)  
                {
                    setinitialdelete1(false);
                }                       
                setinitialRender1(false) ;                     
                return      
            }  
            else
            {    
                setinitialdelete1(false);         
                return 
            }                       
        }, [addMemberPopup1]);
        React.useEffect(() => {         
            if(addMemberPopup2 == true)
            {   if(initialdelete2)  
                {
                    setinitialdelete2(false);
                }                   
                setinitialRender2(false);                     
                return      
            }  
            else
            {    
                setinitialdelete2(false);      
                return 
            }                       
        }, [addMemberPopup2]);

        const ondelete =async (Teammemberid:any)=>{
            setinitialload1(true);
            const vehicleSessionId = authStore.vehicleSessionId || null;
            var res =await api.deletemember('Teammemberid=' + Teammemberid+'&Vehiclesesssionid=' +vehicleSessionId)
            if(res.appId !== null && res.appId.deleted === true)
            {
                setTeamMember1(null);    
                setTeamMember1val(true);           
                setinitialdelete1(true);
                setdisplaybtn(false);
                setinitialload1(false);

            }
            else
            {
                setTeamMember1(null);  
                setTeamMember1val(true);                  
                setinitialdelete1(true);
                setdisplaybtn(false);
                setinitialload1(false);
            }
            await getFullActiveMembers();
        }
        const ondelete2 =async (Teammemberid:any)=>{
            setinitialload2(true);
            const vehicleSessionId = authStore.vehicleSessionId || null;
            var res =await api.deletemember('Teammemberid=' + Teammemberid+'&Vehiclesesssionid=' +vehicleSessionId)
            if(res.appId !== null && res.appId.deleted === true)
            {
                setTeamMember2(null);
                setTeamMember2val(true);
                setinitialdelete2(true);
                setdisplaybtn(false);
                setinitialload2(false);
            }
            else
            {
                setTeamMember2(null);
                setTeamMember2val(true);
                setinitialdelete2(true);
                setdisplaybtn(false);
                setinitialload2(false);
            }
            await getFullActiveMembers();
        }
    return (
        <>       
            <Navbar/>           
            <div className={classes.root}>
                <div className={classes.main}>
                    <div className={"listHeader"}>
                        Who else is on your shift today?
                    </div>
                    <div className={"listBody"}>
                        <Grid container className={"lisSection"} spacing={3}>
                            <Grid item xs={12} sm={6} md={6} >

                                <>
                                {teamMember1 && !initialdelete1 ? (<>
                                <div className={`listItem addedItem`}>
                                    <div className={"titleSection"}>
                                        { teamMember1?.name || "" }
                                        <div className={"removeSection"} 
                                        onClick={() => {
                                            ondelete(teamMember1.id)                                                  
                                        }}
                                        >
                                            <div
                                                className={"removeBtn"}                                               
                                            >
                                                <img src={RemoveIconSvg} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"statusSection"}>
                                       {initialload1 ? (<>
                                        <span className={"loadingSection"}>
                                            <CircularProgress color="inherit" size="20px" />
                                        </span>                                     
                                        <span className={"textSection"}>
                                            { "Removing ..." }
                                        </span>                                        
                                        </>) 
                                        : (<>                                          
                                        {teamMember1val == false ? (<>
                                        <span className={"loadingSection"}>
                                            <CircularProgress color="inherit" size="20px" />
                                        </span>
                                        {teamMember1email !==""?
                                        <span className={"textSection"}>
                                            { "Awaiting Confirmation Via "+teamMember1email }
                                        </span>
                                        :
                                        <span className={"textSection"}>
                                            { "Sending Confirmation Message ..." }
                                        </span>
                                         }
                                        </>) : (<>
                                        <span className={"completedSection"}>
                                            <img src={TickIconSvg} alt="" />
                                        </span>
                                        <span className={"textSection"}>
                                            { "Confirmed" }
                                        </span>
                                        </>)}
                                        </>)}
                                        
                                    </div>
                                </div>
                                </>) : (<>
                                <div className={`listItem noItem`}>
                                    <div className={"iconSection"}>
                                        <img src={UserListIconSvg} alt="" />
                                    </div>
                                    <div className={"addSection"}>
                                        <Button
                                            variant="contained"
                                            className={`${classes.yellowBtn} addBtn`}
                                            onClick={() => { setAddMemberPopup1(true)
                                                       }}
                                        >
                                            Add
                                        </Button>
                                        <AddMemberPopup
                                            popState={addMemberPopup1}
                                            setPopState={setAddMemberPopup1}
                                            setMember={setTeamMember1}
                                            users={teamMember2!==null? users.filter((x:any) => x.id != teamMember2.id):users}  
                                            initialRender = {initialRender1}                    
                                            //member={value}
                                        />
                                    </div>
                                </div>
                                </>)}
                             </>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} >
                                {/* <TeamMemberItem
                                    value={teamMember2}
                                    setValue={setTeamMember2}                            
                                /> */}
                                <>
                                {teamMember2 && !initialdelete2? (<>
                                <div className={`listItem addedItem`}>
                                    <div className={"titleSection"}>
                                        { teamMember2?.name || "" }
                                        <div className={"removeSection"}
                                         onClick={() => {
                                            ondelete2(teamMember2.id) 
                                        }}
                                        >
                                            <div
                                                className={"removeBtn"}                                             
                                            >
                                                <img src={RemoveIconSvg} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"statusSection"}>
                                    {initialload2 ? (<>
                                        <span className={"loadingSection"}>
                                            <CircularProgress color="inherit" size="20px" />
                                        </span>                                     
                                        <span className={"textSection"}>
                                            { "Removing ..." }
                                        </span>                                        
                                        </>) 
                                        : (<> 
                                        {teamMember2val == false ? (<>
                                        <span className={"loadingSection"}>
                                            <CircularProgress color="inherit" size="20px" />
                                        </span>
                                        {teamMember2email !==""?
                                        <span className={"textSection"}>
                                            { "Awaiting Confirmation Via "+teamMember2email }
                                        </span>
                                        :
                                        <span className={"textSection"}>
                                            { "Sending Confirmation Message ..." }
                                        </span>
                                         }
                                        </>) : (<>
                                        <span className={"completedSection"}>
                                            <img src={TickIconSvg} alt="" />
                                        </span>
                                        <span className={"textSection"}>
                                            { "Confirmed" }
                                        </span>
                                        </>)}
                                        </>)}
                                    </div>
                                </div>
                                </>) : (<>
                                <div className={`listItem noItem`}>
                                    <div className={"iconSection"}>
                                        <img src={UserListIconSvg} alt="" />
                                    </div>
                                    <div className={"addSection"}>
                                        <Button
                                            variant="contained"
                                            className={`${classes.yellowBtn} addBtn`}
                                            onClick={() =>{ setAddMemberPopup2(true)
                                                 }}
                                              >
                                            Add
                                        </Button>
                                        <AddMemberPopup
                                            popState={addMemberPopup2}
                                            setPopState={setAddMemberPopup2}
                                            setMember={setTeamMember2}
                                            users={teamMember1!=null? users.filter((x:any) => x.id != teamMember1.id):users}   
                                            initialRender = {initialRender2}                    
                                            //member={value}
                                        />
                                    </div>
                                </div>
                                </>)}
                             </>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={"listFooter"}> 
                     {localStorage.getItem("TeammemberContinue") == "No"?
                     <div>
                        <Button variant="contained" disabled={displaybtn}   onClick={oncontinue} className={classes.yellowBtn} endIcon={<ArrowForwardIos />}>
                            Continue
                        </Button> 
                        </div> :null}                    
                    </div>
                </div>
            </div>
        </>
    );
}

const TeamMemberItem: React.FC<any> = (props): JSX.Element => {
    const classes = useStyles();
    const { value, setValue } = props;
    const [addMemberPopup, setAddMemberPopup] = React.useState<boolean>(false);
    const [users, setUsers] = React.useState<any>([]);
    const { appState, authStore } = useSelector((state: RootState) => state);
    const [isSMAUser, setIsSMAUser] = useState((authStore.data?.IsSMAUser != null) ? authStore.data?.IsSMAUser : true);
    React.useEffect(() => {     
        getusers();      
    }, []);
    const getusers = async()=>{
        var res =await api.getuser("")
        if(res.model !=null)
        {
            setUsers(res.model)
        }        
    }
    React.useEffect(() => {     
        if(value!=null)
        {          
            getMessage(value.id);          
        }            
        }, [value]);

      const getMessage = async(id:any)=>{
            var vehicleSessionId = authStore.vehicleSessionId || null;
            var res =await api.createsession('id=' + id+'&vehicleSessionId=' +vehicleSessionId)
            if(res.appId !==null)
            {
                var res =await api.createemail('id=' + res.appId)                                         
                return true
            } 
            else{
                //setTeamMember1((p: any) => ({ ...p, loading: true }));
                return true
            }             
        } 
    return (
        <>
            {value ? (<>
            <div className={`listItem addedItem`}>
                <div className={"titleSection"}>
                    { value.name || "" }
                    <div className={"removeSection"}>
                        <div
                            className={"removeBtn"}
                            onClick={() => {
                                setValue(null);
                            }}
                        >
                            <img src={RemoveIconSvg} alt="" />
                        </div>
                    </div>
                </div>
                <div className={"statusSection"}>
                    {value.loading ? (<>
                    <span className={"loadingSection"}>
                        <CircularProgress color="inherit" size="20px" />
                    </span>
                    <span className={"textSection"}>
                        { "Awaiting Confirmation Via SMS" }
                    </span>
                    </>) : (<>
                    <span className={"completedSection"}>
                        <img src={TickIconSvg} alt="" />
                    </span>
                    <span className={"textSection"}>
                        { "Confirmed" }
                    </span>
                    </>)}
                </div>
            </div>
            </>) : (<>
            <div className={`listItem noItem`}>
                <div className={"iconSection"}>
                    <img src={UserListIconSvg} alt="" />
                </div>
                <div className={"addSection"}>
                    <Button
                        variant="contained"
                        className={`${classes.yellowBtn} addBtn`}
                        onClick={() => setAddMemberPopup(true)}
                    >
                        Add
                    </Button>
                    <AddMemberPopup
                        popState={addMemberPopup}
                        setPopState={setAddMemberPopup}
                        setMember={setValue}
                        users={users}                      
                        //member={value}
                    />
                </div>
            </div>
            </>)}
        </>
    );
}
const Navbar: React.FC<any> = (props): JSX.Element => {
    
const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        backgroundColor: '#0049a3',
        position: 'sticky',
        zIndex: 1297,
        width: '100%',
        maxWidth: '100%',
        top: 0,
        paddingTop: "59px",
        '& header': {
          boxShadow: "none",
        },
    },
    logo: {
        height: '100%',
        textAlign: "center",
        display: "flex",
        justifyContent: 'center',
        alignItems: 'center',
    },
    logoImg: {
        cursor: 'pointer',
        width: 236,
        [theme.breakpoints.only("xs")]: {
            width: "100%",
        },
    },
    navBarElements: {
        fontSize: '18'
    },
    toolbar: {
        padding: 0,
        height: 59,
    },
    leftHandMenu: {
        height: '100%',
        '& .MuiButton-root': {
            minWidth: 0,
            width: "auto",
            fontWeight: "400",
            '& .MuiButton-iconSizeMedium > *:first-child': {
              fontSize: "26px",
            },
        },
    },
    rightHandMenu: {
        height: '100%',
        display: "flex",
        justifyContent: "flex-end",
        alignItems: 'center',
        '& .MuiButton-root': {
            minWidth: 0,
            width: "auto",
            fontWeight: "400",
            '& .MuiSvgIcon-root': {
              height: "1.6em",
              width: "1.6em",
            },
        },
    },
    rightHandMenuButton: {
        color: '#fff',
    }
}));

const getPermissions = (authStore: IAuthState): IUserType => {
  const permissions: IUserType = {
    IsAdmin: authStore?.data?.IsAdmin || false,
    SMADriver: authStore?.data ? (authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 ? true : false) : false,
    CanViewDashBoard: authStore?.data?.role
      ?.split(",")
      ?.some((p) => p == consts.Permissions.ViewDashboard || p == consts.Permissions.SMAAdminPatientTransportDashboard)
      ? true
      : false,
  };
  return permissions;
};
    const { authStore } = useSelector((state: RootState) => state);
    const classes = useStyles();
    const { navbarContent } = useSelector((state: RootState) => state.appState);
    const leftButtonContent =
      navbarContent != null && navbarContent.leftButtonName ? (
        <Fragment>
        {localStorage.getItem("TeammemberContinue") == "Yes"?
          <LeftHandMenu />
          :null}
        </Fragment>
      ) : (
        <MenuIcon />
      );
    const userPermissions = getPermissions(authStore);
  
    const home = (): void => {
      props.history.push("/");
    };
  
    return (
      <div className={classes.root}>
        <AppBar position="fixed" {...(props.noNavBarShadow ? { elevation: 0 } : {})}>
          <Toolbar className={classes.toolbar} variant="dense">
            <Grid container spacing={0} style={{ height: "100%", width: "100%" }}>
              {props.noLogo && props.humberMenu === null ? (
                <Grid xs={12} item>
                  <div className={classes.rightHandMenu}>
                    <RightHandMenu />
                  </div>
                </Grid>
              ) : (
                <>
                  <Grid item xs={3} sm={4}>
                    <div className={classes.leftHandMenu}>
                      {props.humberMenu === null ? null : props.humberMenu || leftButtonContent}
                    </div>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <div className={classes.logo}>
                      {props.noLogo ? null : <img src={navBarLogo} onClick={home} className={classes.logoImg} alt="logo" />}
                    </div>
                  </Grid>
                  <Grid item xs={3} sm={4}>
                    <div className={classes.rightHandMenu}>
                      <RightHandMenu />
                    </div>
                  </Grid>
                </>
              )}
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
  
export default React.memo(withRouter(TeamMembersWidget));